export default "__VITE_ASSET__Bvj4fiVV__"